"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ImageCover_1 = require("../ImageCover");
var Thumbnail_st_css_1 = require("./Thumbnail.st.css");
var stripMarkTags_1 = require("../stripMarkTags");
exports.Thumbnail = function (props) {
    var commonProps = {
        title: stripMarkTags_1.stripMarkTags(props.title),
        onClick: props.onClick,
        tabIndex: -1,
        'aria-hidden': true,
        'data-hook': 'item-thumbnail',
    };
    var image = React.createElement(ImageCover_1.ImageCover, { src: props.imageUrl, title: commonProps.title });
    if (props.url) {
        return (React.createElement("a", tslib_1.__assign({}, commonProps, { href: props.url, className: Thumbnail_st_css_1.st(Thumbnail_st_css_1.classes.root, {}, props.className) }), image));
    }
    return (React.createElement("span", tslib_1.__assign({}, commonProps, { className: Thumbnail_st_css_1.st(Thumbnail_st_css_1.classes.root, {}, props.className) }), image));
};
//# sourceMappingURL=Thumbnail.js.map